import React from 'react';
import { TableSelectColumnCellTemplate } from 'themes/components';

function TableSelectColumnCell(props) {
    return (
        <TableSelectColumnCellTemplate {...props} />
    )
}

export default TableSelectColumnCell;